<template>
  <div class="row d-flex justify-content-center">
    <div class="col-10 mt-2">
      <el-card shadow="always" class="p-0" style="border-radius: 10px;" :body-style="{ padding: '0px' }">
        <div class="row bg-navy py-2 px-3 mb-5">
          <div class="col-12 text-center">
            <h3 class="mb-0 text-white text-uppercase">New Producer</h3>
          </div>
        </div>
        <div class="mx-5">
          <div class="row mb-5">
            <div class="col-12 text-navy font-weight-bold text-center">
              Producer ABN
              <input-abn-lookup v-model="business.abn" :class="[
                {
                  'form-control is-invalid': form.errors.has(
                    'abn'
                  ),
                },
                'form-control',
              ]" class="w-25 d-inline" />
              <el-button v-loading="loading" class="action-btn btn-green-agent" @click="getABNData" type="primary"
                style="width: 50px;height: 40px;">
                Go
              </el-button>
            </div>
          </div>
          <div v-if="abnData" class="row d-flex justify-content-between">
            <div class="col-5 producer-data">
              <div class="row">
                <div class="col-5 text-navy font-weight-bold p-1">ABN</div>
                <div class="col-7">{{ maskABN(abnData.abn) }}</div>
              </div>
              <div class="row">
                <div class="col-5 text-navy font-weight-bold p-1">ACN</div>
                <div class="col-7">{{ maskABN(abnData.acn) }}</div>
              </div>
              <div class="row">
                <div class="col-5 text-navy font-weight-bold p-1">Entity Name</div>
                <div class="col-7">{{ abnData.name }}</div>
              </div>
              <div class="row">
                <div class="col-5 text-navy font-weight-bold p-1">ABN Status</div>
                <div class="col-7">{{ abnData.status }}</div>
              </div>
              <div class="row">
                <div class="col-5 text-navy font-weight-bold p-1">Trading Name</div>
                <div class="col-7">{{ abnData.name }}</div>
              </div>
              <div class="row">
                <div class="col-5 text-navy font-weight-bold p-1">Entity Type</div>
                <div class="col-7">{{ abnData.entity_type }}</div>
              </div>
              <div class="row">
                <div class="col-5 text-navy font-weight-bold p-1">GST Status</div>
                <div class="col-7"> {{ abnData.gst_status ? 'Registered from ' + abnData.gst_status : '--' }}</div>
              </div>
              <div class="row">
                <div class="col-5 text-navy font-weight-bold p-1">Main Business Location</div>
                <div class="col-7">{{ abnData.state }} {{ abnData.postcode }} </div>
              </div>
            </div>
            <div class="col-5">
              <div class="row">
                <div class="col-4 text-navy font-weight-bold">Business Phone</div>
                <div class="col-8 p-1"><input v-model="business.phone" class="form-control" style="height: 30px;" /></div>
              </div>
              <div class="row">
                <div class="col-4 text-navy font-weight-bold">Business email</div>
                <div class="col-8 p-1"><input v-model="business.email" :class="[
                  {
                    'form-control is-invalid': form.errors.has(
                      'email'
                    ),
                  },
                  'form-control',
                ]" style="height: 30px;" /></div>
              </div>
              <div class="row">
                <div class="col-4 text-navy font-weight-bold">Postal Address</div>
                <div class="col-8 p-1">
                  <google-maps-autocomplete :class="[
                    {
                      'form-control is-invalid': form.errors.has(
                        'extra_attributes.postal_address'
                      ),
                    },
                    'form-control',
                  ]" class="w-100" ref="postalAddress" style="height: 30px" :value="business.postal_address"
                    v-on:address-components="saveAddresses($event, business, 'postal')"
                    @coordinates="saveCoordinates($event, business, 'postal')">
                  </google-maps-autocomplete>
                </div>
              </div>
              <div class="row">
                <div class="col-4 text-navy font-weight-bold">Physical Address</div>
                <div class="col-8 p-1">
                  <google-maps-autocomplete :class="[
                    {
                      'form-control is-invalid': form.errors.has(
                        'extra_attributes.address'
                      ),
                    },
                    'form-control',
                  ]" class="w-100" ref="physicalAddress" style="height: 30px" :value="business.address"
                    v-on:address-components="saveAddresses($event, business, 'address')"
                    @coordinates="saveCoordinates($event, business, 'address')">
                  </google-maps-autocomplete>
                </div>
              </div>
            </div>
          </div>
          <div class="row my-4">
            <div class="col-12 text-right">
              <el-button class="action-btn text-uppercase" type="primary" @click="onSubmit(0)">
                Proceed
              </el-button>
              <el-button class="action-btn text-uppercase btn-green" type="primary" @click="onSubmit(1)">
                Save progress
              </el-button>
            </div>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
import Business from "../../../modelsPortal/Business";
import ABNFormat from "../../../../mixins/ABNFormat";
import InputAbnLookup from '../../../../common/InputAbnLookup.vue';
import AbnLookup from "../../../modelsPortal/common/AbnLookup";
import Form from "form-backend-validation";
export default {
  mixins: [ABNFormat],
  components: { InputAbnLookup },
  props: {
    initial_business: {
      type: Object,
    },
  },
  mounted() {

  },
  data() {
    return {
      business: this.initial_business ? this.initial_business : {
        abn: '',
        acn: '',
        name: '',
        phone: '',
        email: '',
        address: '',
        postal_address: '',
        extra_attributes: {
          postal_address: '',
          address: '',
        },
        lng: '',
        lat: '',
        postal_lng: '',
        postal_lat: '',
      },
      abnData: null,
      loading: false,
      form: new Form(),
    };
  },
  mounted() {
    if (this.business.id) {
      this.getABNData();
    }
  },
  methods: {
    getABNData() {
      this.loading = true;
      let result = this.validateABN(this.business.abn)
      if (result) {
        new AbnLookup().params({ abn: this.business.abn }).get().then((res) => {
          if (res.length == 1) {
            this.abnData = res[0];
            this.business.name = this.abnData.name;
            this.business.acn = this.abnData.acn;
          }
        }).catch((err) => {
          this.abnData = null;
          this.$message.error('Looks like something went wrong.');
        }).finally(_ => {
          this.loading = false;
        })
      } else {
        this.loading = false;
        this.$message.error('Invalid ABN');
      }
    },
    saveAddresses(payload, business, target) {
      if (Array.isArray(business.extra_attributes)) {
        business.extra_attributes = {};
      }

      if (target == 'address') {
        business.extra_attributes.address = payload;
        business.address = payload.formatted_address;
      } else {
        business.extra_attributes.postal_address = payload;
        business.postal_address = payload.formatted_address;
      }
    },
    saveCoordinates(payload, business, target) {
      if (target == "address") {
        business.lat = payload.lat;
        business.lng = payload.lng;
      } else if (target == "postal") {
        business.postal_lat = payload.lat;
        business.postal_lng = payload.lng;
      }
    },
    onSubmit(save_progress) {
      if (this.abnData == null || this.abnData.abn != this.business.abn) {
        this.$message.error('Please check ABN before save any progress or proceed.');
        return;
      }
      this.business.save_progress = save_progress;
      this.business.onboarding_step = save_progress ? 0 : 1;
      this.business.business_status_id = 1; //draft
      new Business(this.business).save().then((result) => {
        if (!this.business.id) {
          var url = window.location.toString();
          url = url.replace("create", `${result.id}/edit`);
          window.history.pushState(null, null, url);
        }
        this.business = result;
        if (!save_progress)
          this.$emit('save-data', this.business);
        else {
          this.$message.success('Saved Successfully!');
        }
      }).catch((errors) => {
        this.form.errors.record(errors.response.data.errors);
      });
      //this.$emit('save-data', this.business);
    }
  },
};
</script>
<style scoped>
.producer-data .row:nth-of-type(odd) div {
  background-color: #f4f4f5;
}

.producer-data .row:nth-of-type(even) div {
  background: #FFFFFF;
}
</style>
